<script>
	// libraries

	// components
	import ColumnChart from '../components/ColumnChart.svelte'

	// other
	import { formatDayShort, getWeekday } from '../utils'
	import { dataAttacks } from '../data'

	// data

	// ///////////////////////////////////////////////////////////
	// process data
	// ///////////////////////////////////////////////////////////

	const key = 'airstrikes_shelling_artillery_ukraine'

	const color = '#88A8BA'

	const dateInvasion = new Date('2022-02-19') // this is between two of our weeks. real date: 2022-02-24

	const tooltipDateFct = (d) =>
		d
			? `${getWeekday(d.start_date)} <b>${formatDayShort(d.start_date)}</b> – ${getWeekday(d.end_date)} <b>${formatDayShort(d.end_date)}</b>`
			: ''

	const tooltipValueFct = (d) =>
		d
			? `
    <div style="color: #fc5757">${d.airstrikes_shelling_artillery_russia} russische Angriffe</div>
    <div style="color: #88A8BA">${d.airstrikes_shelling_artillery_ukraine} ukrainische Angriffe</div>
  `
			: ''
	export let hovered
</script>

<ColumnChart
	bind:hovered
	data={dataAttacks}
	{color}
	{key}
	{tooltipDateFct}
	{tooltipValueFct}
	tooltipWidth={180}
	axis={false}
	invert={true}
	yTicks={[200]} />

<style lang="scss">
</style>
